import React from 'react';

function OlympicsT() {
  return <div></div>;
}

export default OlympicsT;
